<template>
  <div>
    <v-row>
      <v-col cols="12" md="8">
        <h2>
          <v-row dense>
            <v-col cols="12">
              <span style="display: inline-block;vertical-align: top;margin-right: 20px;">
                <v-icon class="mr-2">
                  mdi-truck-outline
                </v-icon>
                配車計画
              </span>
              <span style="display: inline-block;vertical-align: top;" class="text-h6 font-weight-regular">
                {{ targetDate | date_format('YYYY') }}/
              </span>
              <span class="text-h4 font-weight-light">
                {{ targetDate | date_format('MM') }}
              </span>
              <div style="display: inline-block;vertical-align: top">
                <v-btn
                  icon
                  class="font-weight-bold"
                  @click="previousButtonClickEvent"
                >
                  <v-icon large>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="font-weight-bold"
                  @click="nextButtonClickEvent"
                >
                  <v-icon large>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
                <cs-date-picker
                  :date.sync="targetDate"
                  type="month"
                  @dateChangedCallback="targetDateChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <v-btn
                      v-model="targetDate"
                      v-bind="attrs"
                      v-on="on"
                      elevation="0"
                      color="primary"
                      dark
                      fab
                      small
                    >
                      <v-icon>mdi-calendar-month-outline</v-icon>
                    </v-btn>
                  </template>
                </cs-date-picker>
              </div>
            </v-col>
          </v-row>
        </h2>
      </v-col>
      <v-col cols="12" md="4" class="text-right">
        <allocation-switch-button
          :current-view="currentView"
          @switchView="switchView"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-tabs
          v-model="selectedNum"
          right
          class="main-card"
          background-color="main-card"
          @change="changeTableHeaders"
        >
          <v-tab
            v-for="tab_member in tabMembers"
            :key="tab_member.value"
          >
            {{ targetDate | date_format('M月') }}第{{ tab_member.value }}週
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-card
          flat
          class="rounded-card"
        >
          <v-data-table
            :headers="tableHeaders"
            :items="drivers"
            :items-per-page="-1"
            disable-sort
            hide-default-footer
          >
            <template v-slot:[`header.sun`]="{ header }">
              <span :class="header.value">{{ header.text.toUpperCase() }}</span>
            </template>
            <template v-slot:[`header.sat`]="{ header }">
              <span :class="header.value">{{ header.text.toUpperCase() }}</span>
            </template>
            <template v-slot:[`item.driver`]="{ item }">
              <v-avatar
                color="primary"
                size="30"
              >
                <v-img
                  v-if="item.image_url"
                  :src="item.image_url"
                />
                <span v-else class="primary white--text" style="font-size: 80%">
                  {{ item.name.slice(0, 2) }}
                </span>
              </v-avatar>
              &nbsp;<small>{{ item.name }}</small>
            </template>
            <template v-slot:[`item.sun`]="{ item }">
              <week-day-cell
                v-if="item.schedules"
                :target-driver-id="item.id"
                :item="targetOfDay(item.schedules, 'sun')"
              />
            </template>
            <template v-slot:[`item.mon`]="{ item }">
              <week-day-cell
                v-if="item.schedules"
                :target-driver-id="item.id"
                :item="targetOfDay(item.schedules, 'mon')"
              />
            </template>
            <template v-slot:[`item.tue`]="{ item }">
              <week-day-cell
                v-if="item.schedules"
                :target-driver-id="item.id"
                :item="targetOfDay(item.schedules, 'tue')"
              />
            </template>
            <template v-slot:[`item.wed`]="{ item }">
              <week-day-cell
                v-if="item.schedules"
                :target-driver-id="item.id"
                :item="targetOfDay(item.schedules, 'wed')"
              />
            </template>
            <template v-slot:[`item.thu`]="{ item }">
              <week-day-cell
                v-if="item.schedules"
                :target-driver-id="item.id"
                :item="targetOfDay(item.schedules, 'thu')"
              />
            </template>
            <template v-slot:[`item.fri`]="{ item }">
              <week-day-cell
                v-if="item.schedules"
                :target-driver-id="item.id"
                :item="targetOfDay(item.schedules, 'fri')"
              />
            </template>
            <template v-slot:[`item.sat`]="{ item }">
              <week-day-cell
                v-if="item.schedules"
                :target-driver-id="item.id"
                :item="targetOfDay(item.schedules, 'sat')"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AllocationSwitchButton from '../components/_SwitchButton'
import WeekDayCell from '../components/_WeekDayCell'

export default {
  name: 'AllocationWeekly',
  components: {
    AllocationSwitchButton,
    WeekDayCell,
  },
  mixins: [],
  props: {
    currentView: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      menuButtonSelected: null,
      current_page: 1,
      selectedNum: 0,
      showTargetDatePicker: false,
      targetDate: null,
      tabMembers: [],
      tableHeaders: [],
      allocationPlans: [],
      drivers: [],
      targetDays: [],
      formattedDate: null
    }
  },
  computed: {},
  watch: {
    menuButtonSelected (newVal) {
      this.$emit('switchView', newVal)
    },
    targetDate () {
      this.selectedNum = 0
      this.refreshTabMembers()
      this.changeTableHeaders()
    },
  },
  created() {
    this.targetDate = this.$dayjs().format("YYYY-MM-DD")
  },
  methods: {
    ...mapActions('DriverAllocationDriver', {
      fetchDrivers: 'index'
    }),
    targetOfDay (schedules, weekName) {
      let target_schedule = schedules.find((v) => v.week === weekName)
      if (target_schedule) {
        return target_schedule
      } else {
        return { day: null, week: null, counter: 0 }
      }
    },
    /**
     *
     * @param viewType
     */
    switchView (viewType) {
      this.menuButtonSelected = viewType
    },
    /**
     * タブの生成を行う.
     */
    refreshTabMembers () {
      // 月初1日の位置
      let startingDate = this.$dayjs(this.targetDate).date(1)
      let weekNum = startingDate.day()
      let baseDate = this.$dayjs(this.targetDate).date(1).add(-weekNum, 'days')

      this.tabMembers = []
      let startWeekDate = baseDate
      let week_num = this.week_num()
      for (let i = 0; i < week_num; i++) {
        let endWeekDate   = this.$dayjs(startWeekDate).add(6, 'days')
        if (startWeekDate <= this.$dayjs() && endWeekDate >= this.$dayjs()) {
          this.selectedNum = i
        }
        this.tabMembers.push({ value: i+1, start_date: startWeekDate.format('YYYY-MM-DD'), end_date: endWeekDate.format('YYYY-MM-DD') })
        startWeekDate = this.$dayjs(startWeekDate).add(7, 'days')
      }
    },
    week_num () {
      const end = this.$dayjs(this.targetDate).endOf('month');
      const startDay= this.$dayjs(this.targetDate).startOf('month').day()
      const endDay= end.day()
      const endDate= end.date()
      return (startDay -1 + endDate + (endDay=== 0 ? 0 : 7 -endDay)) /7;
    },
    /**
     * テーブルヘッダーに反映するデータの構築
     */
    changeTableHeaders () {
      this.tableHeaders = []
      this.targetDays = []

      this.tableHeaders.push({ value: 'driver', text: 'ドライバー', width: '16%' })

      // 月初1日の位置
      let startingDate = this.$dayjs(this.targetDate).date(1)
      let weekNum = startingDate.day()
      let baseDate = this.$dayjs(this.targetDate).date(1).add(-weekNum, 'days')

      if (this.selectedNum === 0) {
        // 第一週
      } else  {
        baseDate = baseDate.add(this.selectedNum, 'weeks')
      }

      let requestTargetDates = []
      // 日曜日の位置から配列作成
      for (let i = 0; i < 7; i++) {
        let regDate = this.$dayjs(baseDate).add(i, 'days')
        let label = '-'
        if (regDate.month() === startingDate.month()) {
          label = regDate.format('M/D') + '（' + this.weekLabel(regDate.day()) + '）'
          requestTargetDates.push(regDate.format('YYYY-M-D'))
        }
        this.targetDays.push(regDate.format('YYYY-M-D'))
        // value: sun, mon...., text: M/D(日, 月....)
        this.tableHeaders.push({ value: this.weekName(regDate.day()), text: label, align: 'center', width: '12%' })
      }

      let {0 : a ,length : l, [l - 1] : b} = requestTargetDates;
      let params = { start_date: a, end_date: b, type: 'weekly' }
      this.setVariable(params)
    },
    setVariable (params) {
      this.drivers = []
      this.fetchDrivers({ start_date: params['start_date'], end_date: params['end_date'], type: params['type'] }).then((content) => {
        this.drivers = content.drivers
      })
    },
    /**
     * 週を表す数値を曜日(英字)に変換して返す.
     * @param num { Number }
     * @return {string}
     */
    weekName (num) {
      let name = null
      switch (num) {
        case 0:
          name = 'sun'
          break
        case 1:
          name = 'mon'
          break
        case 2:
          name = 'tue'
          break
        case 3:
          name = 'wed'
          break
        case 4:
          name = 'thu'
          break
        case 5:
          name = 'fri'
          break
        case 6:
          name = 'sat'
          break
        default:
          name = ''
          break
      }
      return name
    },
    /**
     * 週を表す数値を曜日に変換して返す.
     * @param num { Number } 週番号
     * @return {string}
     */
    weekLabel(num) {
      let label = null
      switch (num) {
        case 0:
          label = '日'
          break
        case 1:
          label = '月'
          break
        case 2:
          label = '火'
          break
        case 3:
          label = '水'
          break
        case 4:
          label = '木'
          break
        case 5:
          label = '金'
          break
        case 6:
          label = '土'
          break
        default:
          label = ''
          break
      }
      return label
    },
    /**
     * 前月に戻るボタン クリックイベント
     */
    previousButtonClickEvent () {
      this.targetDate = this.$dayjs(this.targetDate).add(-1, 'months').format('YYYY-MM-DD')
    },
    /**
     * 次月へ進むボタン クリックイベント
     */
    nextButtonClickEvent () {
      this.targetDate = this.$dayjs(this.targetDate).add(1, 'months').format('YYYY-MM-DD')
    },
    /**
     * カレンダー日付変更　コールバック
     */
    targetDateChangedCallback (value) {
      this.targetDate = value;
    },
  }
}
</script>

<style scoped lang="scss">
.sun {
  color: red;
}
.sat {
  color: blue;
}
</style>
